import { Role } from '@piwikpro/users-crate';

export class UserRolePass {
  constructor(
    private readonly allAccessRole: 'OWNER',
    private readonly currentUserRole: Role,
  ) {}

  isAllowed(context: any, next: () => boolean): boolean {
    if (this.currentUserRole === this.allAccessRole) return true;

    if (this.currentUserRole === 'USER' && context.role === this.allAccessRole) return false;

    return next();
  }
}
